<template>
  <div v-if="vMemorialHallDetailed.MemorialHallSearchApiModel!=null" class="memorialhall">
    <!-- header start -->
    <van-nav-bar
      :title="vMemorialHallDetailed.MemorialHallSearchApiModel.Title"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    >
    </van-nav-bar>
    <div class="navBarSpace"></div>
    <!-- header end -->

    <img v-if="this.img" :src="this.img" class="memorialhall_bg" />
    <img v-else src="@/assets/images/memorialhall_bg/default.jpg" class="memorialhall_bg" />

    <section class="my-swipe-panel">
      <van-swipe class="my-swipe" :loop="false" indicator-color="orange">
        <van-swipe-item>
          <div class="memorialhall01">
            <div class="content">
              <!-- 单人头像 -->
              <div
                class="singleContent"
                v-if="vMemorialHallDetailed.MemorialHallSearchApiModel.DeceasedInformationApiModelList.length<=1"
              >
                <van-image
                  width="145"
                  height="186"
                  fit="cover"
                  radius="4"
                  :src="vMemorialHallDetailed.MemorialHallSearchApiModel.DeceasedInformationApiModelList[0].HeadPhoto"
                />
                <div
                  class="name"
                >{{vMemorialHallDetailed.MemorialHallSearchApiModel.DeceasedInformationApiModelList[0].DeceasedName}}</div>
                <P
                  class="date"
                >{{vMemorialHallDetailed.MemorialHallSearchApiModel.DeceasedInformationApiModelList[0].OutPutBirthdayDateDesc}}-{{vMemorialHallDetailed.MemorialHallSearchApiModel.DeceasedInformationApiModelList[0].OutPutPassAwayDateDesc}}</P>
              </div>
              <!-- 双人头像 -->
              <div class="doubleContent" v-else>
                <div
                  v-for="item in vMemorialHallDetailed.MemorialHallSearchApiModel.DeceasedInformationApiModelList"
                  :key="item.SerialNumber"
                >
                  <div class="item">
                    <van-image
                      width="120"
                      height="152"
                      fit="cover"
                      radius="4"
                      :src="item.HeadPhoto"
                    />
                    <div class="name">{{item.DeceasedName}}</div>
                    <P class="date">{{item.OutPutBirthdayDateDesc}}-{{item.OutPutPassAwayDateDesc}}</P>
                  </div>
                </div>
              </div>
              <div class="des">
                <div v-html="departedSketch"></div>
              </div>
              <div class="totalView">
                已有
                <span
                  class="corange"
                >{{vMemorialHallDetailed.MemorialHallSearchApiModel.ClickCount}}</span>次纪念
              </div>
            </div>

            <div class="rightContent">
              
            </div>
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="memorialhall02">
              <div v-for="item in vMemorialHallDetailed.MemorialHallSearchApiModel.DeceasedInformationApiModelList"
              :key="item.SerialNumber" class="sz-info">
                <p>姓名:{{item.DeceasedName}}</p>
                <p>性别:{{item.Sex}}</p>
                <p>籍贯:{{item.OriginalhomeAddress}}</p>
                <p>生辰:{{item.OutPutBirthdayDateDesc}}</p>
                <p>忌日:{{item.OutPutPassAwayDateDesc}}</p>
                <p>生肖:{{item.Zodiac}}</p>
              </div>
          </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="memorialhall03">
            <p>
              您是第
              <span
                class="corange"
              >{{vMemorialHallDetailed.MemorialHallSearchApiModel.ClickCount}}</span>位前来吊唁的人。
            </p>
            <p class="des">
              今天是公历{{vMemorialHallDetailed.CurrentTime}}，{{vMemorialHallDetailed.WeekCn}};
              <br />
              {{vMemorialHallDetailed.LunarCalendar}}。
            </p>

            <p
              class="box"
              v-for="item in vMemorialHallDetailed.MemorialHallSearchApiModel.DeceasedInformationApiModelList"
              :key="item.SerialNumber"
            >
              {{item.DeceasedName}}已经离开我们
              <span class="corange">{{item.LeaveDay}}</span>天;
              <br />
              {{item.PassAwayDateTime}}是{{item.DeceasedName}}的忌日;
              <br />距今还有
              <span class="corange">{{item.DeathDay}}</span>天。
            </p>
          </div>
        </van-swipe-item>
      </van-swipe>
    </section>
    
  </div>
</template>
<script>
import soshm from "soshm";
import VueMoment from 'vue-moment'
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      isPlaying: true,
      isWorshipShow: false,
      vMemorialHallDetailed: {},
      departedSketch: "",
      isFollow : false,
      img : "",
    };
  },
  computed: {
    ...mapGetters(["currentToken"])
  },
  components: {},
  deactivated: function() {
    this.isWorshipShow = false;
  },
  methods: {
    init(id) {
      var that = this;
      var options = {
        type: "GetMemorialHallSearchApiById",
        id: id
      };
      that.$store.dispatch(options).then(res => {
        that.isFollow = res.MemorialHallSearchApiModel.IsFollow;
        that.vMemorialHallDetailed = res;
        var deceasedInformation =
          res.MemorialHallSearchApiModel.DeceasedInformationApiModelList[0];
        if (
          deceasedInformation.DepartedSketch != null &&
          deceasedInformation.DepartedSketch != ""
        ) {
          if (deceasedInformation.DepartedSketch.length > 20) {
            this.departedSketch = deceasedInformation.DepartedSketch.substring(
              0,
              19
            );
          } else {
            this.departedSketch = deceasedInformation.DepartedSketch;
          }
        } else {
          this.departedSketch = "死亡不是生命的终点 <br/> 遗忘才是生命的终结";
        }
      });
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    goVisitorList() {
      this.$router.push("/VisitorList");
    },
    goPersonInfo(id) {
      this.$router.push("/PersonInfo?id=" + id);
    }
    /* clickMusicPlay(){
        if(!this.isPlaying){
          //this.$refs.player.play()
          this.isPlaying = true;
          console.log('播放-----');
        }else{
          this.$refs.player.pause()
          this.isPlaying = false;
          console.log('暂停-----');
        }
      },*/
  },
  created() {
    var id = this.$route.query.id;
    this.img = this.$route.query.img;
    this.init(id);
    //console.log(id);
  }
};
</script>
<style scoped>
.memorialhall {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 50px;
  width: 100%;
  height: 100%;
}
.memorialhall_bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 46px;
  bottom: 50px;
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.my-swipe-panel {
  height: 100%;
  padding-bottom: 96px;
  position: relative;
}
.my-swipe {
  height: 100%;
  width: 100%;
}
.memorialhall01 {
  position: relative;
}
.memorialhall01 > .leftContent {
  position: absolute;
  top: 4%;
  left: 10px;
}
.memorialhall01 > .leftContent > .gradeIcon {
  width: 46px;
  height: 46px;
  object-fit: contain;
}
.memorialhall01 > .rightContent {
  position: absolute;
  top: 8%;
  right: 10px;
}
.memorialhall01 > .rightContent > .item {
  width: 30px;
  height: 30px;
  background-color: #24a378;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
}
.memorialhall01 .content {
  padding: 0 20px;
}
.memorialhall01 .content .des {
  text-align: center;
  font-size: 14px;
  margin-top: 14px;
}
.memorialhall01 .content .totalView {
  text-align: center;
  font-size: 14px;
  margin-top: 4px;
}
.memorialhall01 > .rightContent > .musicBtn {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  z-index: 10;
  background: url("~@/assets/images/worship/musicBtn.png") center no-repeat;
  background-size: 100% 100%;
  margin-bottom: 10px;
}
.musicBtnPlay {
  -webkit-animation: mymove 1.5s infinite linear;
  animation: mymove 1.5s infinite linear;
}
@-webkit-keyframes mymove {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes mymove {
  from {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
.singleContent {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 20%;
}
.singleContent > .name {
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  margin-top: 6px;
}
.singleContent > .date {
  font-size: 12px;
  color: #999;
  text-align: center;
}
.doubleContent {
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  margin-top: 25%;
}
.doubleContent> div > .item {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 130px;
  overflow: hidden;
  margin: 0 10px;
}
.doubleContent> div > .item > .name {
  font-weight: bold;
  font-size: 20px;
  text-align: center;
  margin-top: 6px;
}
.doubleContent> div > .item > .date {
  font-size: 12px;
  color: #999;
  text-align: center;
}
.memorialhall02 > .sz-info {
  margin: 8% 30px;
}
.memorialhall02 > .sz-info > p {
  font-size: 15px;
  text-align: left;
}
.memorialhall03 {
  padding: 8% 30px;
}
.memorialhall03 > p {
  font-size: 15px;
  text-align: left;
}
.memorialhall03 > .des {
  margin-top: 20px;
}
.memorialhall03 > .box {
  background-color: rgba(0, 0, 0, 0.08);
  margin: 4px 0;
  padding: 6px;
}
.memorialhall01,
.memorialhall02,
.memorialhall03 {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding-bottom: 85px;
}
.jibaiBtn {
  position: fixed;
  right: 15px;
  bottom: 135px;
  width: 56px;
  height: 56px;
  line-height: 56px;
  background-color: rgba(0, 0, 0, 0.55);
  border-radius: 50%;
  text-align: center;
  font-size: 16px;
  color: #fff;
  z-index: 9;
}
.visit-box {
  position: fixed;
  right: 0;
  bottom: 50px;
  z-index: 8;
  width: 100%;
  padding: 30px 10px;
}
.visit-box .item {
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.worshipBtn {
  position: fixed;
  right: 15px;
  bottom: 191px;
  z-index: 10;
}
.worshipBtn .btn {
  display: block;
  width: 50px;
  height: 50px;
  font-size: 15px;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  background-color: #eee;
  border-radius: 50%;
}
.jiayuanBtn {
  background-color: green !important;
  box-shadow: 0 1px 2px green;
}
.fudiBtn {
  background-color: orange !important;
  box-shadow: 0 1px 2px orange;
}
.daijiBtn {
  position: fixed;
  right: 15px;
  bottom: 201px;
  width: 50px;
  height: 50px;
  background-color: rgba(0, 0, 0, 0.55);
  border-radius: 50%;
  text-align: center;
  font-size: 13px;
  color: #fff;
  z-index: 8;
  line-height: 1.2;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 6px;
}
</style>
